<div [style]="customStyle">
  <p-calendar #monthCalendar [(ngModel)]="selectedDate" view="month" dateFormat="mm" [ngClass]="{
    'calendar-default': size === 'default',
    'calendar-compact': size === 'compact',
    'calendar-xs': size === 'xs'
  }" (onSelect)="onDateSelected()" [placeholder]="placeholder" (onInput)="onDateSelected()"/>
</div>

<!-- [dir]="direction" [readonlyInput]="true" -->